import { render, staticRenderFns } from "./IconTelegram.vue?vue&type=template&id=4582ff52"
import script from "./IconTelegram.vue?vue&type=script&lang=js"
export * from "./IconTelegram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports